module.exports = __webpack_public_path__ + "media/images/samples/home/news/n3-87fc6d3f471abcc1d105f14cc7d16b58.png";